import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldDictionary = (item, index) => {
  return {
    index,
    key: uuidv4(),
    id: item?.dictionary_id,
    name: item?.dictionary_name,
    description: item?.dictionary_description,
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
  }
}

export const getDictionaryListApi = ({ param, is_active, page, size }) => {
  const params = removeEmpty({
    param,
    is_active,
    page,
    size,
  })

  const config = {
    method: 'get',
    url: '/api/v1/dictionary/',
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.items) {
        return responseSuccess({
          data: {
            items: _.map(res.data?.items, mapFieldDictionary),
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const createDictionaryApi = ({ dictionary_name, dictionary_description, is_active }) => {
  const data = {
    dictionary_name,
    dictionary_description,
    is_active,
  }

  const config = {
    method: 'post',
    url: '/api/v1/dictionary/',
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getDictionaryByIdApi = (id) => {
  const config = {
    method: 'get',
    url: `/api/v1/dictionary/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: mapFieldDictionary(res.data?.[0]) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const deleteDictionaryByIdApi = (id) => {
  const config = {
    method: 'delete',
    url: `/api/v1/dictionary/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateDictionaryByIdApi = ({
  id,
  dictionary_name,
  dictionary_description,
  is_active,
}) => {
  const data = {
    dictionary_name,
    dictionary_description,
    is_active,
  }

  const config = {
    method: 'patch',
    url: `/api/v1/dictionary/${id}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
